module.exports = __webpack_public_path__ + "static/media/paw.1518c91f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Story/assets/paw.svg
// module id = 372
// module chunks = 0